import { useChatActions, useChatStatus } from '@mui/x-chat/headless';
import { type RefObject } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { isTruthy } from 'common';

import { type AgenticChatController } from '../../../components/AgenticChat/context';

interface AgenticChatStopOnEscapeProps {
  chatRef: RefObject<HTMLDivElement | null>;
  agenticChatVisibility: AgenticChatController['agenticChatVisibility'];
}

/**
 * Stops the in-flight agent run when Escape is pressed while focus is inside the open chat.
 *
 * Renders nothing: it only exists to reach the chat runtime, so it must be a child of `ChatBox`.
 */
export function AgenticChatStopOnEscape(props: AgenticChatStopOnEscapeProps) {
  const { chatRef, agenticChatVisibility } = props;
  const chatActions = useChatActions();
  const { isStreaming } = useChatStatus();

  useHotkeys('escape', () => chatActions.stopStreaming(), {
    enabled: isStreaming && agenticChatVisibility === 'Open',
    enableOnFormTags: true,
    // Unlike a false `enabled` callback, this skips without swallowing Escape meant for the page.
    ignoreEventWhen: (event) =>
      !(event.target instanceof Node && isTruthy(chatRef.current?.contains(event.target))),
    preventDefault: true,
  });

  return null;
}
